import onmount from 'onmount'

onmount('[data-component=faq-section]', function () {
  $(this).click(() => {
    $(this).find('[data-show=answer]').slideToggle()
  })
})
